// Reggie Credits constants shared by the pages and the server (no server-only
// imports — the header pop-up bundles this file). Server side:
// lib/reggie_credits.js.
//
// Credits pay for the fal.ai calls: Uniform Swap (+ its fix pass) runs Gemini
// 3 Pro image edit at 2K (~$0.15 a call), Sky Removal runs Gemini 2.5 Flash
// image (~$0.04). One credit ≈ one Flash call, so a swap costs 3.

export const REGGIE_COSTS = {
  uniform_swap:     3,
  uniform_swap_fix: 3,
  sky_removal:      1,
};

export const REGGIE_ACTION_LABELS = {
  uniform_swap:     "Uniform Swap",
  uniform_swap_fix: "Uniform Swap fix",
  sky_removal:      "Sky Removal",
};

// Free credits each calendar month (UTC), by who is signed in. Unused
// monthly credits don't roll over; bought credits never expire and are
// spent only once the month's free credits are gone. Guests can't run
// Uniform Swap (sign-in only), so theirs cover Sky Removal.
export const REGGIE_MONTHLY = {
  guest:      3,
  member:     10,
  subscriber: 60,
  admin:      Infinity,   // sales@ — never charged
};

export const REGGIE_TIER_LABELS = {
  guest:      "Guest",
  member:     "Free account",
  subscriber: "Subscriber",
  admin:      "Admin",
};

// Packs sold as variants of the "Reggie Credits" Shopify product
// (tools/reggie-credits/create-credits-product.mjs). The orders webhook
// grants `credits` by variant id, never by anything on the line item.
export const REGGIE_PACKS = [
  { id: "25",  credits: 25,  price: "4.99"  },
  { id: "60",  credits: 60,  price: "9.99"  },
  { id: "150", credits: 150, price: "19.99" },
];

export const REGGIE_CUSTOMER_PROP = "_reggie_customer_id";

// Browser events: open the pop-up (e.g. after an out_of_credits answer) and
// refresh the header balance after a spend.
export const REGGIE_OPEN_EVENT    = "reggie-credits:open";
export const REGGIE_CHANGED_EVENT = "reggie-credits:changed";
